import { consumer } from '@tock/coretypes';
import AppConstants from 'constants/AppConstants';
import protos from 'utils/consumerProto';

const { PrivateDiningRequest } = protos;

export function requestPrivateDining(pdr: Partial<consumer.PrivateDiningRequest>): ApiAction {
  const postProto = '/consumer/private-dining';
  const request = PrivateDiningRequest.fromObject(pdr);

  return {
    TockApi: {
      postProto,
      type: AppConstants.PRIVATE_DINING_REQUEST,
      request,
      toast: 'Your request has been submitted',
    },
  };
}
